import {NgModule} from '@angular/core';

import {PrestationActeTableComponent} from './prestation-acte-table.component';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
    ],
  exports: [PrestationActeTableComponent],
  declarations: [PrestationActeTableComponent],
  providers: [],
})
export class PrestationActeTableModule {
}
